"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftActionsValidationUtils = void 0;

var yup = _interopRequireWildcard(require("yup"));

var _gifting = require("../../gifting.types");

var VALIDATION_RULES = {
  [_gifting.GiftActionsFields.Actions]: {
    required: 'The gift actions need to be defined.'
  }
};
var gifterQuestionSchema = yup.string().label('Custom questions').nullable().default(null).trim().max(255).when(_gifting.GiftActionsFields.RecipientActions, function (ra, schema) {
  return ra.includes('capture_question') ? schema.required() : schema;
});
var gifterAffidavitSchema = yup.string().label('Custom terms & conditions').nullable().default(null).trim().max(255).when(_gifting.GiftActionsFields.RecipientActions, function (ra, schema) {
  return ra.includes('capture_affidavit') ? schema.required() : schema;
});
var captureRaSchema = yup.array(yup.string()).default([]);
var giftActionsSchema = yup.number().default(_gifting.GiftActions.AllAllowed).required(VALIDATION_RULES[_gifting.GiftActionsFields.Actions].required);
var giftActionsValidationSchema = yup.object().shape({
  [_gifting.GiftActionsFields.Actions]: giftActionsSchema,
  [_gifting.GiftActionsFields.RecipientActions]: captureRaSchema,
  [_gifting.GiftActionsFields.GifterAffidavit]: gifterAffidavitSchema,
  [_gifting.GiftActionsFields.GifterQuestion]: gifterQuestionSchema
});
var giftActionsDefaultValues = giftActionsValidationSchema.cast({
  [_gifting.GiftActionsFields.Actions]: _gifting.GiftActions.AllAllowed,
  [_gifting.GiftActionsFields.RecipientActions]: [],
  [_gifting.GiftActionsFields.GifterQuestion]: '',
  [_gifting.GiftActionsFields.GifterAffidavit]: ''
});
var GiftActionsValidationUtils = {
  giftActionsValidationSchema,
  giftActionsDefaultValues
};
exports.GiftActionsValidationUtils = GiftActionsValidationUtils;